<template>
  <div class="mt-5">
    <RfTable
      :tableData="{ totalCount: messages.length }"
      :loading="!!messages"
      class="rf-settings-table-data"
    >
      <template #thead>
        <tr>
          <td class="text-black-2! w-0 text-xs font-bold!">Status</td>
          <td class="text-black-2! w-48 text-xs font-bold!">Date</td>
          <td class="text-black-2! w-48 text-xs font-bold!">Type</td>
          <td class="text-black-2! text-xs font-bold!">Message</td>
        </tr>
      </template>
      <template #tbody>
        <tr
          v-for="message in [...messages].reverse()"
          :key="message.id"
          class="text-body border-beige-10 text-grey-1 h-full border-b border-solid last:border-b-0"
        >
          <td class="align-top!">
            <div class="flex items-start justify-center">
              <div
                class="mt-1 inline-block h-3 w-3 rounded-full"
                :class="{
                  'bg-error-1': message.status === 'error',
                  'bg-green-50': message.status === 'completed',
                }"
              ></div>
            </div>
          </td>
          <td class="align-top!">
            <div class="flex items-start">
              <div>
                {{ dayjs(message.created_at).format("YYYY-MM-DD HH:mm") }}
              </div>
            </div>
          </td>
          <td class="align-top!">
            <div class="flex items-start">
              <div>
                {{ message.message_type }}
              </div>
            </div>
          </td>
          <td>
            <div v-for="value in message.body" :key="value">{{ value }}</div>
          </td>
        </tr>
      </template>
    </RfTable>
  </div>
</template>

<script setup>
import RfTable from "@/blocks/RfTable/RfTable.vue";
import dayjs from "dayjs";

defineProps({ messages: { type: Array, default: () => [] } });
</script>
